module.exports = __webpack_public_path__ + "static/media/closeDiv.b29c0c47.svg";